<template>
  <Layout>
    <el-row id="templates-view">
      <transition name="fade">
        <preview-modal-component
            v-if="showPreviewModal"
            :show-preview-modal="showPreviewModal"
            :target-widget="previewTargetWidget"
            @close="showPreviewModal = false"/>
      </transition>
      <el-col :span="24" :md="{ span: 24 }">
        <h1 class="has-subheading">What will you create today?</h1>
        <p>Customizable templates fit for your website.</p>

        <ThemesFilter/>

        <el-container class="container-lg" :direction="isTablet ? 'vertical' : 'horizontal'">

          <el-aside width="200px" class="c-aside">
            <types-filter-component class="mb-8" @type-select="triggerTypeFilter"/>
            <categories-filter-component @category-select="triggerFilter"/>
          </el-aside>

          <el-main>
            <el-row :class="$style.searchWrapper" :gutter="10">
              <el-col
                  :lg="{ span: 8, offset: 16 }"
                  :sm="{ span: 14, offset: 10 }">
                <el-input
                    v-model.trim="sortFilter"
                    placeholder="Filter by Name"
                    suffix-icon="el-icon-search"></el-input>
              </el-col>
            </el-row>


            <widget-gallery-component :widget-arr="dynamicTemplateData"
                                      @choose-widget="chooseWidget"
                                      @preview-widget="previewWidget"/>
          </el-main>

          <create-campaign-modal-component :modal-visible="createCampaignModalVisible"
                                           :chosen-widget="chosenWidgetID"
                                           @close-modal="createCampaignModalVisible = false"/>
        </el-container>
      </el-col>
    </el-row>
  </Layout>
</template>

<script>
import Layout from '@layouts/main.vue'
import { authComputed } from '@state/helpers'
import PreviewModal from '@components/modals/PreviewModal/PreviewModal.vue'
import CreateCampaignModal from '@components/modals/CreateCampaignModal/CreateCampaignModal.vue'
import WidgetGallery from '@components/WidgetGallery/WidgetGallery.vue'
import CategoriesFilter from '@components/templates/CategoriesFilter.vue'
import TypesFilter from '@components/templates/TypesFilter.vue'
import { formatWidgetFromApi } from '@utils/formatWidgetApi'
import isTabletMixin from '@mixins/isTablet'
import { mapGetters, mapActions } from 'vuex'
import ThemesFilter from '@components/templates/ThemesFilter.vue'
import _cloneDeep from 'lodash/cloneDeep'

export default {
  page: {
    title: 'Templates',
    meta: [{ name: 'description', content: 'Templates' }],
  },
  name: 'TemplatesView',
  components: {
    ThemesFilter,
    Layout,
    'preview-modal-component': PreviewModal,
    'widget-gallery-component': WidgetGallery,
    'types-filter-component': TypesFilter,
    'categories-filter-component': CategoriesFilter,
    'create-campaign-modal-component': CreateCampaignModal,
  },
  mixins: [isTabletMixin],
  data: function () {
    return {
      chosenWidgetID: '',
      typeFilter: 'all',
      categoryFilter: 'all',
      sortFilter: '',
      showPreviewModal: false,
      previewTargetWidget: '',
      createCampaignModalVisible: false,
    }
  },
  computed: {
    ...authComputed,
    ...mapGetters('templates', [
      'sortedTemplatesForSelectedTheme',
    ]),
    dynamicTemplateData() {
      // Convert the object to an array
      const templatesArray = Object.values(this.sortedTemplatesForSelectedTheme)
      // Now you can use array methods like .filter()
      return templatesArray.filter((template) => {
        // Safe check for category filter
        const matchCategoryFilter = this.categoryFilter === 'all' ||
            (template.info && template.info.tags && template.info.tags.includes(this.categoryFilter.toLowerCase()))

        // Safe check for type filter
        const matchTypeFilter = this.typeFilter === 'all' ||
            (template.info && template.info.tags && template.info.tags.includes(this.typeFilter.toLowerCase()))

        // Safe check for search filter
        const matchSearchFilter = template.info && template.info.name &&
            template.info.name.toLowerCase().includes(this.sortFilter.toLowerCase())

        return matchCategoryFilter && matchTypeFilter && matchSearchFilter
      })
    },
    getWidgetTemplateByID() {
      return this.$store.getters['templates/getWidgetTemplateByID']
    },
  },
  created() {
    this.loadFonts()
  },
  methods: {
    ...mapActions('fonts', ['loadFonts']),
    chooseWidget(id) {
      if (!this.loggedIn) {
        this.$router.push({ name: 'login' })
      }
      this.chosenWidgetID = id
      this.createCampaignModalVisible = true
    },
    previewWidget(templateID) {
      const widget = _cloneDeep(this.getWidgetTemplateByID(templateID))
      this.previewTargetWidget = formatWidgetFromApi(widget)
      this.showPreviewModal = true
    },
    triggerTypeFilter(type) {
      this.typeFilter = type
    },
    triggerFilter(category) {
      this.categoryFilter = category.value
    },
  },
}
</script>

<style lang="scss">
@import '@assets/sass/design/_mixin.scss';

.c-aside {
  @include asideMenu;
}
</style>

<style lang="scss" module>
.elMain {
  padding: 0 20px 0 70px;
}

.searchWrapper {
  margin: 0 0 40px 0;

  input {
    background-color: transparent;
  }
}
</style>
